import { providerApi } from '@/api/ProviderApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'

const useCancelPatientAppointment = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({ appointmentId }: { appointmentId: number }) =>
			providerApi.cancelAppointment(appointmentId),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['upcoming-appointment'],
			})
		},
	})
}

export { useCancelPatientAppointment }
